import { CallOverrides } from "ethers";
      /* tslint:disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export type DAOExpanderFactoryContractFunctions1 =
  | []
  | [DAOExpanderFactoryContractFunctions]
  | [DAOExpanderFactoryContractFunctions, DAOExpanderFactoryContractEvents];
export type SWEvent = {
  event: DAOExpanderFactoryContractEventType;
  args: any;
}[];

export interface DAOExpanderFactoryContractFunctions {
  deployDAOExpander: (
    deployer: string,
    autIDAddr: string,
    daoTypesAddr: string,
    daoType: number,
    daoAddr: string,
    market: number,
    metadata: string,
    commitment: number,
    overrides?: CallOverrides
  ) => Promise<{wait: () => Promise<DAOExpanderFactoryContractEvents>}>;
}
export interface DAOExpanderFactoryContractEvents {
  events: SWEvent;
}

export enum DAOExpanderFactoryContractEventType {}
